import React, { useState, useRef, useEffect } from 'react';
import ReactStrapTable from "components/reactStrapTable";
// import DownloadIcon from "assets/icon/icon-icon-options-download.svg";
// import DownloadIconHover from "assets/icon/icon-icon-options-download_hover.svg";
import DownloadIcon from 'assets/icon/icon-icon-options-delete.svg';
import DownloadIconHover from 'assets/icon/icon-icon-options-delete-hover.svg';

import { Button } from "reactstrap";
import useAxios from "hooks/useAxios";
import HoverImage from "react-hover-image/build";
import { dateFormate, cellRendererCheck } from 'utils/columns';
import Loader from "components/Loader";
import { cloneDeep } from 'lodash';
import { onExport } from 'utils/helper';


let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: "modifiedDate",
    order: "desc",
    filters: [],
};
const tabledata=[
    {
    dateProcessed:"4/2/2025",
    fileName:"DrugUtilization_DSH123456_20250402005642.csv",
    totalNoOfRecords:"51535",
    successfulRecords:"51530",
    failedRecords:"5",
},
{
    dateProcessed:"4/1/2025",
    fileName:"DrugUtilization_DSH123456_20250402020142.csv",
    totalNoOfRecords:"45659",
    successfulRecords:"45609",
    failedRecords:"50",
},
{
    dateProcessed:"3/31/2025",
    fileName:"DrugUtilization_DSH123456_20250401234642.csv",
    totalNoOfRecords:"8945",
    successfulRecords:"8945",
    failedRecords:"-",
},
{
    dateProcessed:"3/30/2025",
    fileName:"DrugUtilization_DSH123456_20250401225143.csv",
    totalNoOfRecords:"51535",
    successfulRecords:"51535",
    failedRecords:"-",
},
{
    dateProcessed:"3/29/2025",
    fileName:"DrugUtilization_DSH123456_20250402002143.csv",
    totalNoOfRecords:"45659",
    successfulRecords:"45659",
    failedRecords:"-",
},
{
    dateProcessed:"3/28/2025",
    fileName:"DrugUtilization_DSH123456_20250401212645.csv",
    totalNoOfRecords:"8945",
    successfulRecords:"8945",
    failedRecords:"-",
},
{
    dateProcessed:"3/27/2025",
    fileName:"DrugUtilization_DSH123456_20250401214642.csv",
    totalNoOfRecords:"7222",
    successfulRecords:"7222",
    failedRecords:"-",
},
{
    dateProcessed:"3/26/2025",
    fileName:"DrugUtilization_DSH123456_20250401213145.csv",
    totalNoOfRecords:"7223",
    successfulRecords:"7223",
    failedRecords:"-",
},
{
    dateProcessed:"3/25/2025",
    fileName:"DrugUtilization_DSH123456_20250401211642.csv",
    totalNoOfRecords:"7224",
    successfulRecords:"7224",
    failedRecords:"-",
},
{
    dateProcessed:"3/24/2025",
    fileName:"DrugUtilization_DSH123456_20250401211142.csv",
    totalNoOfRecords:"7225",
    successfulRecords:"7225",
    failedRecords:"-",
},
]

const Drugutlization = (props) => {
    const API = useAxios()
    const { tenantID, orgId, randNum } = props
    const [ePrescriptionFileData, setEPrescriptionFileData] = useState(tabledata);
    const [loading, setLoading] = useState(false);
    const [totalItem, setTotalItem] = useState(0);

    // useEffect(() => {
    //     initialFilters = {
    //         currentPage: 1,
    //         pageSize: 10,
    //         orderBy: "modifiedDate",
    //         order: "desc",
    //         filters: [],
    //     };
    //     fetchEPrescriptionFileSummary(initialFilters)
    // }, [randNum]);


    const onPageChange = (filter, hasFilter) => {
        // let detailFilter = cloneDeep(initialFilters);
        // if (hasFilter) {
        //     detailFilter.currentPage = filter.currentPage;
        //     fetchEPrescriptionFileSummary(detailFilter, true);
        // } else {
        //     detailFilter.currentPage = filter.currentPage;
        //     fetchEPrescriptionFileSummary(detailFilter);
        // }
    };

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        // if (hasColFilter) {
        //     initialFilters = { ...initialFilters, ...filter }
        //     let colFilterOn = { ...initialFilters, filters: colChangedFilter };
        //     return onPageChange(colFilterOn, true);
        // }
        // initialFilters = { ...initialFilters, ...filter }
        // onPageChange(initialFilters);
    };


    const handleExport = async (fileId) => {
        // let fileProcessID = "";
        // if (fileId != "" && fileId != undefined && fileId > 0) {
        //     fileProcessID = fileId;
        // }
        // const { access_token } =
        //     JSON.parse(localStorage.getItem('pharmaforce')) || {};
        // const action = `${process.env.REACT_APP_ENDPOINT}/CPDashboard/${tenantID}/Dashboard/dashboardEPrescription?access_token=${access_token}`;
        // onExport(action, fileProcessID);

    };

    // const fetchEPrescriptionFileSummary = async (filter) => {
    //     let payload = { ...filter };
    //     initialFilters = { ...initialFilters, ...filter }
    //     setLoading(true);
    //     if (!tenantID) return null;
    //     try {
    //         const { data } = await API.post(`CPDashboard/${tenantID}/Dashboard/getEPrescriptionfileSummary`, payload,
    //             {
    //                 hasDefaultURL: true,
    //                 hideLoader: false,
    //             }
    //         );
    //         if (data) {
    //             setEPrescriptionFileData(data.items);
    //             setTotalItem(data.totalRecords);
    //             setLoading(false);
    //         } else {
    //             setEPrescriptionFileData([]);
    //             setTotalItem(0);
    //             setLoading(false);
    //         }
    //     } catch (error) { }
    // };

    const cellRenderEdit = (fileId) => {
        return (
            <div className="align-items-center">
                <Button
                    color="link"
                    className="text-primary p-0 text-decoration-none"
                    onClick={() => handleExport(fileId)}
                    title="Download"
                >
                    <HoverImage
                        key="DownloadIcon"
                        src={DownloadIcon}
                        hoverSrc={DownloadIconHover}
                        alt=""
                    />
                </Button>

            </div>
        );
    };

    const columns = [
        {
            dataField: "fileProcessID",
            text: "Options",
            width: 100,
            cellRenderer: (ePrescriptionFileData) => cellRenderEdit(ePrescriptionFileData.fileProcessID),
            show: true,
            hideColFilter: true,
            sort: false,
            action: true,
        },
        {
            dataField: "dateProcessed",
            text: "Date Processed",
            show: true,
            width: 120,
            hideColFilter: true,
            sort: false,
            cellRenderer: (ePrescriptionFileData) => dateFormate(ePrescriptionFileData.dateProcessed),
        },
        {
            dataField: "fileName",
            text: "File Name",
            show: true,
            width: 120,
            hideColFilter: true,
            sort: false,
            cellRenderer: (ePrescriptionFileData) => cellRendererCheck(ePrescriptionFileData.fileName),
        },
        {
            dataField: "totalNoOfRecords",
            text: "Total no. of Records",
            show: true,
            width: 120,
            hideColFilter: true,
            sort: false,
            cellRenderer: (ePrescriptionFileData) => cellRendererCheck(ePrescriptionFileData.totalNoOfRecords),
        },
        {
            dataField: "successfulRecords",
            text: "Successful Records",
            show: true,
            width: 140,
            hideColFilter: true,
            sort: false,
            cellRenderer: (ePrescriptionFileData) => cellRendererCheck(ePrescriptionFileData.successfulRecords),

        },
        {
            dataField: "failedRecords",
            text: "Failed Records",
            show: true,
            width: 140,
            hideColFilter: true,
            sort: false,
            cellRenderer: (ePrescriptionFileData) => cellRendererCheck(ePrescriptionFileData.failedRecords),
        },
    ];

    return (
        <>
            <div>
                <span className='text-primary font-weight-600'>Drug Utilization History</span>
            </div>
            {loading && <Loader opacity={0.01} color="black" />}
            <div
                className="table-card scroll-table position-relative border-0 rounded pt-0 mt-3"
                fixed-height={ePrescriptionFileData.length > 0 ? "fixed-height" : "default"}
            >
                <ReactStrapTable
                    id="dashboardeprescription"
                    fixedColumn
                    columns={columns}
                    data={ePrescriptionFileData}
                    // hasPagination
                    onPageChange={onPageChange}
                    totalRecords={totalItem}
                    onPageSizeChange={onPageSizeChange}
                    pageSize={initialFilters.pageSize}
                    currentPage={initialFilters.currentPage}
                    isHideFilter={true}
                />
            </div>
        </>
    );
};

export default Drugutlization;